import React from 'react';

export default function TimrLogo({ size = 56 }) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
      <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="TIMR clock logo">
        <circle cx="32" cy="32" r="27" fill="#fff" stroke="#0f172a" strokeWidth="4" />
        <circle cx="32" cy="32" r="2.7" fill="#0f172a" />
        <line x1="32" y1="32" x2="32" y2="13" stroke="#0f172a" strokeWidth="4" strokeLinecap="round" />
        <line x1="32" y1="32" x2="45" y2="42" stroke="#ea580c" strokeWidth="4.5" strokeLinecap="round" />
        <circle cx="32" cy="32" r="1.7" fill="#ea580c" />
      </svg>
      <div>
        <div style={{ fontWeight: 800, letterSpacing: '0.08em', fontSize: 24, lineHeight: 1 }}>TIMR</div>
        <div style={{ fontSize: 12, opacity: 0.75 }}>Timesheet Intelligence for Modern Reporting</div>
      </div>
    </div>
  );
}
